import { FaTruck } from "react-icons/fa";
import { getInitialCountryData } from "../../functions/CountryFunctions";

const DELIVERY_TIMES = {
  UK: [4, 6],
  EU: [4, 6],
  US: [7, 10],
  CAD: [18, 19],
  AUD: [18, 19],
  NZ: [11, 14],
};

const DeliveryLine = () => {
  const { selectedCountry } = getInitialCountryData();

  const codeMap = {
    CA: "CAD",
    AU: "AUD",
  };

  const regionKey = codeMap[selectedCountry] || selectedCountry;
  const timeArr = DELIVERY_TIMES[regionKey] || DELIVERY_TIMES.UK;

  const today = new Date();

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + Number(days));
    return d;
  };

  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });

    const j = day % 10;
    const k = day % 100;

    let suffix = "th";
    if (j === 1 && k !== 11) suffix = "st";
    else if (j === 2 && k !== 12) suffix = "nd";
    else if (j === 3 && k !== 13) suffix = "rd";

    return `${day}${suffix} ${month}`;
  };

  const fromDateObj = addDays(today, timeArr[0]);
  const toDateObj = addDays(today, timeArr[1]);
  const fromMonth = fromDateObj.getMonth();
  const toMonth = toDateObj.getMonth();
  let fromDate, toDate;
  if (fromMonth === toMonth) {
    // Only show day in fromDate, full in toDate
    const day = fromDateObj.getDate();
    const j = day % 10;
    const k = day % 100;
    let suffix = "th";
    if (j === 1 && k !== 11) suffix = "st";
    else if (j === 2 && k !== 12) suffix = "nd";
    else if (j === 3 && k !== 13) suffix = "rd";
    fromDate = `${day}${suffix}`;
    toDate = formatDate(toDateObj);
  } else {
    fromDate = formatDate(fromDateObj);
    toDate = formatDate(toDateObj);
  }

  const regionLabelMap = {
    UK: "UK",
    EU: "EU",
    US: "US",
    CAD: "Canada",
    AUD: "Australia",
    NZ: "New Zealand",
  };

  const regionLabel = regionLabelMap[regionKey] || "UK";

  return (
    <div className="si_deliver_line">
      <FaTruck style={{ marginRight: "8px", fontWeight: 500 }} />
      <p style={{ margin: 0 }}>
        Free {regionLabel} delivery {fromDate} – {toDate}
      </p>
    </div>
  );
};

export default DeliveryLine;
